import { render, staticRenderFns } from "./Termine.vue?vue&type=template&id=1f0ac0ea&"
import script from "./Termine.vue?vue&type=script&lang=js&"
export * from "./Termine.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../Users/patri/AppData/Roaming/npm/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports